import { render, staticRenderFns } from "./BioUpgradeModal.vue?vue&type=template&id=6d322e73&scoped=true&"
import script from "./BioUpgradeModal.vue?vue&type=script&lang=js&"
export * from "./BioUpgradeModal.vue?vue&type=script&lang=js&"
import style0 from "./BioUpgradeModal.vue?vue&type=style&index=0&id=6d322e73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d322e73",
  null
  
)

export default component.exports